export default __webpack_public_path__ + "static/media/suva-yellow_circle.14a0b095.png";